import {
    FloatingArrow,
    FloatingFocusManager,
    FloatingPortal,
    arrow,
    autoPlacement,
    autoUpdate,
    useClick,
    useDismiss,
    useFloating,
    useFocus,
    useInteractions,
    useRole,
    shift, flip
} from "@floating-ui/react";
import React, { useRef, useState } from "react";

import "./tooltip.scss";

export type TooltipProps = {
    innerHTML?: string;
    title?: string;
    children?: React.ReactNode;
};

const Tooltip = ({ innerHTML, title, children }: TooltipProps) => {
    const [popoverOpen, setPopoverOpen] = useState(false);

    const closeTooltip = () => setPopoverOpen(false);

    const arrowRef = useRef(null);

    const { refs, floatingStyles, context } = useFloating({
        open: popoverOpen,
        onOpenChange: setPopoverOpen,
        whileElementsMounted: autoUpdate,
        middleware: [autoPlacement(), flip(), shift(), arrow({ element: arrowRef })],
    });

    const focus = useFocus(context);
    const click = useClick(context);
    const role = useRole(context);
    const dismiss = useDismiss(context);

    const { getFloatingProps, getReferenceProps } = useInteractions([
        click,
        focus,
        role,
        dismiss,
    ]);

    return (
        <span className="tooltip-component">
            <i
                ref={refs.setReference}
                className="tooltip-component__icon las la-info-circle"
                {...getReferenceProps()}
            />
            {popoverOpen && (
                <FloatingPortal>
                    <FloatingFocusManager context={context}>
                        <div
                            role="tooltip"
                            ref={refs.setFloating}
                            style={floatingStyles}
                            className="tooltip-component__wrapper"
                            {...getFloatingProps()}
                        >
                            <span className="tooltip-component__dismiss">
                                <i
                                    className={"las la-times"}
                                    onClick={() => closeTooltip()}
                                />
                            </span>
                            {title && (
                                <h3 className="pl-2 tooltip-component__title">
                                    {title}
                                </h3>
                            )}
                            {children && <div className="p-2">{children}</div>}
                            {innerHTML && (
                                <div className="p-2 tooltip-component__body">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: innerHTML,
                                        }}
                                    />
                                </div>
                            )}

                            <FloatingArrow
                                ref={arrowRef}
                                context={context}
                                strokeWidth={1}
                                stroke="#e0e3eb"
                                fill="white"
                                className="tooltip-component__arrow"
                            />
                        </div>
                    </FloatingFocusManager>
                </FloatingPortal>
            )}
        </span>
    );
};

export { Tooltip };
